import { useCallback, useEffect, useState } from 'react'
import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { Loader, Snackbar, useSlideAnimation, getCurrentPosition, getAddress } from 'sfy-react'
import { setLoader, setSnackbar } from '../../../redux/common'
import Header from '../../../common/components/Header'
import Footer from '../Footer'
import { getValueFromAdressComponent } from '../../../utils'
import { setConsumerDetails, setUserDetails } from '../../../redux/user'
// import { userList } from '../../../utils/login'

const ChatLayout = () => {
  const dispatch = useDispatch()
  const location = useLocation()

  const consumerDetails = useSelector((state) => state.user.consumerDetails)
  const showLoader = useSelector((state) => state.common.showLoader)
  const loaderMessage = useSelector((state) => state.common.loaderMessage)
  const snackbar = useSelector((state) => state.common.snackbar)

  const [allDetailsAvailable, setAllDetailsAvailable] = useState(false)
  const [messageResponse, setMessageResponse] = useState('')
  const [messages, setMessages] = useState([])
  const [country, setCountry] = useState('')
  const [currentLocation, setCurrentLocation] = useState('')

  useEffect(() => {
    const userDetails = window.userList.find((user) => user.consumerID === sessionStorage.getItem('consumerID'))

    if (userDetails && sessionStorage.getItem('authorization') && +sessionStorage.getItem('consumerID')) {
      dispatch(
        setConsumerDetails({
          consumerID: +sessionStorage.getItem('consumerID'),
          accessToken: {
            ID: sessionStorage.getItem('authorization'),
            consumerID: +sessionStorage.getItem('consumerID'),
          },
          productUniqueID: sessionStorage.getItem('productUniqueID'),
        })
      )
      dispatch(setUserDetails(userDetails))
    }
    setAllDetailsAvailable(true)
  }, [dispatch])

  const handleAutoDetect = useCallback(async () => {
    dispatch(setLoader(true))
    try {
      let location = await getCurrentPosition()
      let request = {
        location: new window.google.maps.LatLng(location.coords.latitude, location.coords.longitude),
      }
      let result = await getAddress(request)
      let addrComponents = result.address_components
      let landmark = result.formatted_address
      let state = getValueFromAdressComponent(addrComponents, 'administrative_area_level_1')
      let city = getValueFromAdressComponent(addrComponents, 'locality')
      let country = getValueFromAdressComponent(addrComponents, 'country')
      let pinCode = getValueFromAdressComponent(addrComponents, 'postal_code')

      setCountry(country)
      setCurrentLocation({ landmark, city, state, country, pinCode })
    } catch (e) {
      console.log(e)
    }
    dispatch(setLoader(false))
  }, [dispatch])

  useEffect(() => {
    handleAutoDetect()
  }, [dispatch, handleAutoDetect])

  const animationClass = useSlideAnimation(location.pathname, true) //this is for mobile view only
  return (
    allDetailsAvailable &&
    (consumerDetails.accessToken?.ID ? (
      <>
        {Boolean(showLoader) && <Loader loaderText={loaderMessage} />}
        {snackbar.message && (
          <Snackbar
            isRTL={window.isDirectionRTL}
            message={snackbar.message}
            type={snackbar.type}
            callback={() => {
              dispatch(setSnackbar({}))
            }}
            imagePath={require(`../../../assets/images/${snackbar.type}-alert.svg`)}
          />
        )}
        <Header />
        <div className={`wrapper`}>
          <div className={`width-100 ${animationClass[0]} ${animationClass[1]} animation-container`}>
            <Outlet context={{ currentLocation, messageResponse, setMessageResponse, messages, setMessages }} />
          </div>
        </div>
        <Footer country={country} />
      </>
    ) : (
      <Navigate to='/login' replace />
    ))
  )
}

export default ChatLayout
